<router-outlet></router-outlet>
<web-loader [show]="isLoaderVisible$ | ngrxPush"></web-loader>
